const initialState = {
    portBusy: {
        isPortBusy: false,
        portBusyFor: '',
        message: '',
    },
    // Transient UI feedback: { kind: 'success' | 'error' | 'info', message, id }.
    toast: null,
}

const reducer = function (state, action) {
    if (typeof state === 'undefined')
        state = JSON.parse(JSON.stringify(initialState))
    switch (action.type) {
        case 'SET_PORT_BUSY':
            return Object.assign({}, state, {
                portBusy: action.payload,
            })

        case 'RESET_PORT_BUSY':
            let newState = Object.assign({}, state, {
                portBusy: JSON.parse(JSON.stringify(initialState.portBusy)),
            })
            return newState

        case 'SET_DEVICE_TOAST':
            return Object.assign({}, state, {
                toast: action.payload,
            })

        case 'CLEAR_DEVICE_TOAST':
            if (action.payload && state.toast && state.toast.id !== action.payload) {
                return state
            }
            return Object.assign({}, state, { toast: null })

        default:
            return state
    }
}

const setPortBusy = function (portBusyData) {
    let newPortBusyData = JSON.parse(JSON.stringify(portBusyData))
    return {
        type: 'SET_PORT_BUSY',
        payload: newPortBusyData,
    }
}
const resetPortBusy = function () {
    return {
        type: 'RESET_PORT_BUSY',
    }
}

let toastId = 0
const setDeviceToast = function (kind, message) {
    toastId += 1
    return {
        type: 'SET_DEVICE_TOAST',
        payload: { kind, message, id: toastId },
    }
}
const clearDeviceToast = function (id) {
    return {
        type: 'CLEAR_DEVICE_TOAST',
        payload: id,
    }
}

export {
    reducer as default,
    initialState as deviceInitialState,
    setPortBusy,
    resetPortBusy,
    setDeviceToast,
    clearDeviceToast,
}
